var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('audio',{attrs:{"autoplay":"","src":require('@/assets/alert.mp3')}}),_c('div',{staticClass:"white--text f-16",staticStyle:{"max-width":"335px"}},[_vm._v(" "+_vm._s(_vm.message)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }